export default __webpack_public_path__ + "751ca8d5fa5e89439e2787917c2d7c7e.png";